export * from './browserPlatform';
export * from './scanRequests';

export enum RetailerSyncModeTypes {
  CLIENT_SIDE = 'clientSide',
  SERVER_SIDE = 'serverSide',
  HYBRID = 'hybrid',
}

export enum RetailerSyncReferrerTypes {
  ONBOARDING = 'onBoarding',
  SYNC_ALL = 'syncAll',
  ACCOUNTS_PAGE = 'accountsPage',
  ACCOUNTS_CAROUSEL = 'accountsCarousel',
  REVIEWS = 'reviews',
  AUTO_SYNC = 'autoSync',
  CHECKOUT = 'checkout',
  FIX = 'fix',
}

export type RetailerSyncReferrer = RetailerSyncReferrerTypes;

export type RetailerSyncMode = RetailerSyncModeTypes;

export enum SyncInitiationTrigger {
  USER = 'user',
  TEST = 'test',
  AUTO_SYNC = 'auto_sync',
  CHECKOUT = 'checkout',
}

export enum RetailerSyncFlowTypes {
  CONNECT_ONLY = 'connect_only',
  CONNECT = 'connect',
  FIX = 'fix',
  RETRY_SYNC = 'retrySync',
  SYNC = 'sync',
  AUTO_SYNC = 'autoSync',
  CHECKOUT = 'checkout',
}

export type RetailerSyncFlow = RetailerSyncFlowTypes;

export type RetailerSyncStatus =
  | 'queued'
  | 'pending'
  | 'connecting'
  | 'userintervention'
  | 'connected'
  | 'scanning'
  | 'scanning_completed'
  | 'processing_rewards'
  | 'completed'
  | 'skipped'
  | 'timed_out'
  | 'error';

export type BrowserInfo = { userAgent: string; timeZone: string; locale: string };

export type LoginAccountId = {
  id: string;
  type: string;
  groupId?: string;
  primeBenefitType?: string;
  [key: string]: unknown;
};

export type CreateContextRequest = {
  parentRetailerId: number;
  scanTrigger: string;
  browserInfo: BrowserInfo;
  url: string;
  userLoginInfo: LoginAccountId & { username: string };
  syncId: string;
  syncBatchId: string;
  syncInitiator: SyncInitiationTrigger;
  syncMode: RetailerSyncMode;
  appId: string;
};
